export { default } from './homeGetStarted';
